import { RequestConfig } from '@/interface'

const PRIFIX = 'fpgl/khxx/'

const customerConfig: RequestConfig = {
  // 删除客户基本信息
  delJbxxKhxx: {
    url: `${PRIFIX}delJbxxKhxx`,
    method: 'post'
  },
  // 获取客户单基本信息
  getJbxxKhxx: {
    url: `${PRIFIX}getJbxxKhxx`,
    method: 'get'
  },
  // 客户基本信息列表
  jbxxKhxxList: {
    url: `${PRIFIX}jbxxKhxxList`,
    method: 'post'
  },
  // 客户基本信息
  jbxxKhxxListNew: {
    url: `${PRIFIX}jbxxKhxxListNew`,
    method: 'post'
  },
  // 添加或者更新客户信息
  saveOrUpdateKhxx: {
    url: `${PRIFIX}saveOrUpdateKhxx`,
    method: 'post'
  },
  // 客户基本信息-二维码url
  khxxEwmUrl: {
    url: `${PRIFIX}khxxEwmUrl`,
    method: 'post'
  },
  // 通过二维码添加或者更新客户信息
  addKhxxEwm: {
    url: `${PRIFIX}addKhxxEwm`,
    method: 'post'
  },
  // 客户信息文件上传
  uploadKhxx: {
    url: `${PRIFIX}upload`,
    method: 'post'
  },
  // 批量上传客户信息
  batchUploadKhxx: {
    url: `${PRIFIX}uploadKhxx`,
    method: 'post'
  },
  // 客户信息列表下载
  khxxDownload: {
    url: `${PRIFIX}khxxDownload`,
    method: 'post'
  },
  // 企业信息详情
  firmInfo: {
    url: 'qyxx/info',
    method: 'get'
  },
  // 企业信息列表
  firmList: {
    url: 'qyxx/list',
    method: 'get'
  }
}
export default customerConfig
